// extracted by mini-css-extract-plugin
module.exports = {"information":"StaffingInformation_information__Alv8q","tableText":"StaffingInformation_tableText__3jImZ"};